import React from "react";
import { Card, CardBody, CardHeader, CardTitle, Form, Row } from "reactstrap";
import shallow from "zustand/shallow";
import useCurrentSaleStore from "stores/SaleStore";
import LabelAndInput from "../../LabelAndInput";
import useCurrentDealStore from "stores/DealStore";
import ChildrenModal from "components/modals/ChildrenModal";
import formNavigationUtils from "utils/formNavigationUtils";
import SellerFeesTable from "./SellerFeesTable";
import { DealStatus } from "constants/Constants";
import useCurrentLeaseStore from "../../../../../../stores/LeaseStore";

// Seller fees calculations are done here
const LeaseFeesModal = ({ modal, toggle }) => {
	// Sale store
	const sales = useCurrentSaleStore((state) => ({ ...state }), shallow);
	const lease = useCurrentLeaseStore((state) => ({ ...state }), shallow);

	// Deal store
	const { type } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
		}),
		shallow
	);

	// All the editable input fields, labels, and their edit functions
	let fields = [
		{
			name: "leaseBankFee",
			value: lease.bankFee,
			onChange: (e) => lease.editField("bankFee", Number(e) || 0),
			label: "Bank(Acquisition) Fee",
		},
		{
			name: "securityDeposit",
			value: lease.securityDeposit,
			onChange: (e) => lease.editField("securityDeposit", Number(e) || 0),
			label: "Security Deposit",
		},
		{
			name: "leaseDocFee",
			value: lease.docfee,
			onChange: (e) => lease.editField("docfee", Number(e) || 0),
			label: "Doc Fee",
		},
		{
			name: "sellerDealerSmog",
			value: sales.dealerSmog,
			onChange: sales.editDealerSmog,
			label: "Dealer Smog",
		},
		{
			name: "sellerStateSmog",
			value: sales.stateSmog,
			onChange: sales.editStateSmog,
			label: "Smog Cert",
		},
		{
			name: "gpsService",
			value: lease.gpsService,
			onChange: (e) => lease.editField("gpsService", Number(e) || 0),
			label: "GPS Service",
		},
	];

	// Returns input fields and a text field that shows the total of the inputs
	return (
		<ChildrenModal
			toggle={toggle}
			modal={modal}
			size="lg"
			modalTitle="Lease Fees"
			children={
				<Form onKeyDown={formNavigationUtils}>
					<Card>
						<CardHeader>
							<CardTitle tag="h3">Manage Fees</CardTitle>
						</CardHeader>
						<CardBody>
							<Row>
								{fields.map((obj) => (
									<div className="col-md-6 mb-2">
										<LabelAndInput
											name={obj.name}
											readOnly={type !== DealStatus.PENDING}
											value={obj.value}
											label={obj.label}
											onChange={obj.onChange}
											buttonLabel={true}
											btnClass="btn btn-md btn-primary disabled w-100"
										/>
									</div>
								))}
							</Row>
						</CardBody>
					</Card>
					<SellerFeesTable />
				</Form>
			}
		/>
	);
};

export default LeaseFeesModal;
